import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { ThemeService } from '../services/theme.service';

@Directive({
  selector: '[appTiles]'
})
export class TilesDirective {
  siteProperties: any;
  baseUrl: string;
  themeList: any;

  constructor(public el: ElementRef, public renderer: Renderer2, private themeService: ThemeService) {
    themeService.getBaseUrl().once('value', snapshot => {
      this.siteProperties = [];
      snapshot.forEach(snap => {
        if (snap.val().state === '1') {
          this.siteProperties.push({
            baseUrl: snap.val().base_url
          });
        }
      });
      this.baseUrl = this.siteProperties[0].baseUrl;
    });

    this.themeService.getThemeList().once('value', snapshot => {
      // if (localStorage.getItem('themeList')) {
      //   this.themeList = JSON.parse(localStorage.getItem('themeList'));
      // } else {
      this.themeList = [];
      snapshot.forEach(snap => {
        if (snap.val().state === '1') {
          this.themeList.push({
            primaryColor: snap.val().primary_color,
            secondaryColor: snap.val().secondary_color,
            tertiaryColor: snap.val().tertiary_color,
            backgroundImage: this.baseUrl + snap.val().background_image,
            logo: this.baseUrl + snap.val().logo,
            opacity: snap.val().opacity,
            titleBarBackgroun: snap.val().title_bar_background,
            titleBarFontColor: snap.val().title_bar_font_color,
            pageBackgroundImage: this.baseUrl + snap.val().page_background_image,
            pageFontColor: snap.val().page_font_color,
            pageSettings: snap.val().page_settings,
            advancedSettins: snap.val().advanced_settings,
            imageShadow: snap.val().page_image_shadow,
            imageBorder: snap.val().page_image_border
          });
        }
      });
      localStorage.setItem('themeList', this.themeList);
    // }

      console.log('image shadow', this.themeList[0].imageShadow);
      console.log('image border', this.themeList[0].imageBorder);
      console.log('base url', this.baseUrl);
      this.renderer.setStyle(el.nativeElement, 'cursor', 'pointer');
      if (this.themeList[0].advancedSettings === 0 && this.themeList[0].pageSettings === 0) {
        this.renderer.setStyle(el.nativeElement, 'box-shadow', 'none');
        this.renderer.setStyle(el.nativeElement, 'border', 'none');
      } else {
        this.renderer.setStyle(el.nativeElement, 'box-shadow', this.themeList[0].imageShadow);
        this.renderer.setStyle(el.nativeElement, 'border', this.themeList[0].imageBorder);
      }
      
      // this.renderer.setStyle(el.nativeElement, 'min-height', '100%');
    });
  }

}
